module.exports = __webpack_public_path__ + "img/bg_device_mobile.65985d50.svg";